import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Spin } from 'antd';
import { toast } from 'react-toastify';
import ContentLayout from '../../../layout/ContentLayout';
import { Container } from '../../../components/content';
import protocolApi from '../../../api/protocol-api';
import styles from '../../../styles/mobileInfoPage.module.scss';
import dayjs from 'dayjs';

const badgeStyle = {
  display: 'inline-block',
  padding: '2px 10px',
  borderRadius: '12px',
  fontSize: '12px',
  fontWeight: 500,
};

const formatAuthor = (createdBy) => {
  if (!createdBy) return null;
  const name = [createdBy.firstName, createdBy.lastName].filter(Boolean).join(' ').trim();
  return name || createdBy.email || null;
};

export default function VerzijeProtokola() {
  const { id } = useParams();
  const [versions, setVersions] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchVersions = useCallback(async () => {
    setLoading(true);
    const { data, success, message } = await protocolApi.getVersionHistory(id);
    if (success) {
      setVersions(data || []);
    } else {
      toast.error(message || 'Greška pri učitavanju verzija protokola');
    }
    setLoading(false);
  }, [id]);

  useEffect(() => {
    fetchVersions();
  }, [fetchVersions]);

  return (
    <Container>
      <Link to="/protokoli?tab=protokoli" className="link_btn" style={{ marginBottom: '12px' }}>
        <img alt="back" src="/assets/icons/chevron.svg" />
        <span>Nazad</span>
      </Link>

      <ContentLayout pt={true}>
        <h2 className={styles.pageTitle} style={{ marginBottom: '24px' }}>
          Verzije protokola
        </h2>

        {loading ? (
          <div className={styles.loadingContainer}>
            <Spin size="large" />
          </div>
        ) : versions.length === 0 ? (
          <p>Nema podataka o verzijama.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {versions.map((version) => (
              <div
                key={version._id}
                style={{ border: '1px solid #eee', borderRadius: 8, padding: 16 }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 8,
                  }}
                >
                  <strong>v{version.versionNumber}</strong>
                  <span
                    style={{
                      ...badgeStyle,
                      backgroundColor: version.status === 'active' ? '#e6f4ea' : '#f0f0f0',
                      color: version.status === 'active' ? '#1e7e34' : '#555',
                    }}
                  >
                    {version.status === 'active' ? 'Aktivna verzija' : 'Arhivirana'}
                  </span>
                </div>
                <div style={{ color: '#555', fontSize: 13, marginBottom: 4 }}>
                  Kreirano: {version.createdAt ? dayjs(version.createdAt).format('DD.MM.YYYY. HH:mm') : '-'}
                  {formatAuthor(version.createdBy) && ` — ${formatAuthor(version.createdBy)}`}
                </div>
                {version.versionNotes && (
                  <div style={{ fontSize: 13 }}>Napomena: {version.versionNotes}</div>
                )}
              </div>
            ))}
          </div>
        )}
      </ContentLayout>
    </Container>
  );
}
